import React, { useState, useEffect } from 'react';
import './Single.css';
import { db } from '../../firebaseConfig';

import FadeIn from 'react-fade-in';
import "animate.css/animate.min.css";

const Single = () => {

    const [postTitle, setpostTitle] = useState('');
    const [postDescription, setpostDescription] = useState('');
    const [postImg, setpostImg] = useState(null);

    useEffect(() => {
        const pathId = window.location.pathname;

        db.collection('posts').doc(pathId.substr(8)).get().then(item => {
            const field = item._delegate._document.data.value.mapValue.fields;
            setpostTitle(field.PostTitle.stringValue);
            setpostDescription(field.PostDescription.stringValue);
            setpostImg(field.PostImg.stringValue);
        });
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0)
    }, []);

    return(
        <>
        { postTitle && postDescription && postImg &&
        <FadeIn className="single">
            <div className="single-img">
                <img src={ postImg } alt="post" />
            </div>
            <div className="single-content">
                <h1>{ postTitle }</h1>
                <p>{ postDescription }</p>
            </div>
        </FadeIn>
        }
        </>
    );
}

export default Single;